import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';

import { deleteContentItem as deleteContentItemAPI } from '@/api/v4/content-items.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';
import { contentItemInEditModeState } from './feed.state';
import { useToggleContentItemSidebar } from './sidebar/use-toggle-content-item-sidebar';

export const useDeleteContentItem = () => {
  const { t } = useTranslation('feed');
  const queryClient = useQueryClient();
  const [contentItemInEditMode, setContentItemInEditMode] = useAtom(
    contentItemInEditModeState,
  );
  const { navigateToFeedTab } = useToggleContentItemSidebar();

  const mutation = useMutation({
    mutationFn: deleteContentItemAPI,
    onSuccess: async (_data, contentItemId) => {
      if (contentItemInEditMode?.id === contentItemId) {
        setContentItemInEditMode(null);
        navigateToFeedTab();
      }
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ContentItems] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.FeedContentItems],
        }),
      ]);
      notify({
        message: t`deleteSuccess`,
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`deleteError`,
      });
      console.error(error.message);
    },
  });

  return {
    deleteContentItem: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
